import api from "@/components/customAxios/Axios";
import { useToast } from "@/components/toast";
import { useLoader } from "@/context/loaderContext";
import { useEffect, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import { TiArrowUnsorted } from "react-icons/ti";
import Header from "@/components/Header";
import { useParams, useNavigate } from "react-router-dom";
type userLogsType = {
	candidates_crossed_cutoff: number;
	creation_time: string;
	cvs_uploaded: number;
	job_name: string;
	assessment_sent_count: string;
	assessment_completed_count: string;
};

const UserLogsInDetail = () => {
	const { setLoading } = useLoader();
	const toast = useToast();
	const params = useParams();
	const navigate = useNavigate();
	const [userLogs, setUserLogs] = useState<Array<userLogsType>>([]);
	const [userName, setUserName] = useState("");
	const [nameQuery, setNameQuery] = useState("");
	const [sortParam, setSortParam] = useState("creation_time");
	const [sortOrder, setSortOrder] = useState("desc");
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	const [itemsPerPage, setItemsPerPage] = useState(10);

	useEffect(() => {
		localStorage.getItem("role") !== "product-owner" ||
			localStorage.getItem("role") !== "bluetick-admin"
			? navigate("/jobList")
			: "";
	}, []);

	const handlePageClick = (page: number) => {
		setCurrentPage(page);
	};

	const getUserLogs = async () => {
		setLoading(true);
		try {
			const res = await api.get(`/dashboard/user-details`, {
				params: {
					email: params.id,
					page: currentPage,
					search: nameQuery,
					per_page: itemsPerPage,
					sort_field: sortParam,
					order: sortOrder,
				},
			});

			setUserLogs(res.data.job_details);
			setUserName(res.data.user_name);
			setTotalPages(res.data.pagination.total_pages);
		} catch (err: any) {
			setLoading(false);
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Error fetching user logs",
				description: err.response?.data?.error || err.response?.data?.message || "An error occurred.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};
	const toggleParams = (field: string) => {
		setSortParam(field);
		setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
	};

	useEffect(() => {
		// Set a timeout for the search
		const handler = setTimeout(() => {
			getUserLogs();
		}, 2000);

		// Cleanup the timeout if searchQuery changes before 2 seconds
		return () => clearTimeout(handler);
	}, [nameQuery]);
	useEffect(() => {
		getUserLogs();
	}, [currentPage, itemsPerPage, sortOrder, sortParam]);

	return (
		<>
			<Header></Header>
			<div className=" mx-3 md:px-5 lg:px-8 mt-2 ">
				<div className="flex flex-wrap justify-between items-center md:gap-4 gap-2 w-full">
					{/* User Logs Heading */}
					<div>
						<h3 className="text-2xl font-semibold mb-2 font-sans mt-4 text-center">
							{userName?.split(" ")[0]}'s Log
						</h3>
					</div>

					{/* Right Section: Search and Dropdown */}
					<div className="w-full md:w-auto flex flex-wrap justify-center md:justify-end items-center md:gap-4 gap-2">
						{/* Search Input */}
						<div className="mt-4">
							<input
								type="text"
								value={nameQuery}
								onChange={(e) => setNameQuery(e.target.value)}
								placeholder="Search..."
								className="w-full md:w-[250px] p-2 border border-gray-300 rounded"
							/>
						</div>

						{/* Items Per Page Dropdown */}
						<div>
							<select
								value={itemsPerPage}
								onChange={(e) => setItemsPerPage(parseInt(e.target.value))}
								className="hover:bg-[#0B67BC] hover:text-white p-2.5 rounded-lg shadow-md border focus:ring focus:ring-green-200 focus:outline-none"
							>
								{[5, 10, 15, 20, 25, 30].map((num) => (
									<option
										key={num}
										value={num}
										className="font-light bg-white text-black"
									>
										{num} per page
									</option>
								))}
							</select>
						</div>
					</div>
				</div>

				{/* user log table */}
				<div className="bg-white rounded-lg shadow overflow-x-auto mt-3 border">
					<table className="w-full min-w-[800px] text-sm text-left text-gray-600">
						<thead className="bg-gray-200 p-2">
							<tr>
								<th className="p-3 text-left min-w-[180px]">Role</th>

								<th className="p-3 text-left min-w-[120px] max-w-[120px]">
									Total CV's{" "}
									<button
										className="text-blue-500 ml-1"
										onClick={() => toggleParams("cv")}
									>
										<TiArrowUnsorted />
									</button>
								</th>
								<th className="p-3 text-left min-w-[110px] max-w-[130px]">
									Assessments Sent
									<button
										className="text-blue-500 ml-2"
										onClick={() => toggleParams("assessment_sent")}
									>
										<TiArrowUnsorted />
									</button>
								</th>
								<th className="p-3 text-left min-w-[140px] max-w-[155px]">
									Assessments Completed{" "}
									<button
										className="text-blue-500 ml-2"
										onClick={() => toggleParams("assessment_completed")}
									>
										<TiArrowUnsorted />
									</button>
								</th>
								<th className="p-3 text-left min-w-[140px] max-w-[140px]">
									Qualified Candidate{" "}
									<button
										className="text-blue-500 ml-1"
										onClick={() => toggleParams("qualified_candidates")}
									>
										<TiArrowUnsorted />
									</button>
								</th>
								<th className="p-3 text-left min-w-[120px] max-w-[125px]">
									Time{" "}
									<button
										className="text-blue-500 ml-2 mt-1"
										onClick={() => toggleParams("creation_time")}
									>
										<TiArrowUnsorted />
									</button>
								</th>
							</tr>
						</thead>
						{userLogs.length > 0 ? (
							<tbody>
								{userLogs.map((elem, key) => (
									<tr
										key={key}
										className="border-b border-gray-300 hover:bg-slate-100"
									>
										{/* User Column */}
										<td className="p-3 font-medium  ">{elem.job_name}</td>
										{/* Other Columns */}
										<td className="p-3 text-gray-700">{elem.cvs_uploaded}</td>
										<td className="p-3 text-gray-700">
											{elem.assessment_sent_count}
										</td>
										<td className="p-3 text-gray-700">
											{elem.assessment_completed_count}
										</td>
										<td className="p-3 text-gray-700">
											{elem.candidates_crossed_cutoff}
										</td>
										<td className="p-3 text-gray-700">{elem.creation_time}</td>
									</tr>
								))}
							</tbody>
						) : (
							<tbody>
								<tr>
									<td
										colSpan={6}
										className="p-3 text-center font-semibold text-2xl text-gray-500"
									>
										No Data Found
									</td>
								</tr>
							</tbody>
						)}
					</table>
				</div>

				{/* pagination */}
				{totalPages > 0 && (
					<div className="flex items-center justify-center mt-14 mb-4 space-x-1">
						<button
							onClick={() => handlePageClick(currentPage - 1)}
							disabled={currentPage === 1}
							className={`${currentPage === 1
									? "bg-blue-100 cursor-not-allowed"
									: "bg-blue-500 hover:bg-blue-400"
								} text-white px-2 py-1 rounded-full transition duration-300`}
						>
							<FaChevronLeft size={14} />
						</button>

						{Array.from({ length: totalPages }, (_, index) => (
							<button
								key={index}
								onClick={() => handlePageClick(index + 1)}
								className={`w-8 h-8 flex items-center justify-center rounded-full text-xs font-medium transition duration-300 ${currentPage === index + 1
										? "bg-blue-600 text-white"
										: "bg-blue-100 text-blue-600 hover:bg-blue-200"
									}`}
							>
								{index + 1}
							</button>
						))}

						<button
							onClick={() => handlePageClick(currentPage + 1)}
							disabled={currentPage === totalPages}
							className={`${currentPage === totalPages
									? "bg-blue-100 cursor-not-allowed"
									: "bg-blue-500 hover:bg-blue-400"
								} text-white px-2 py-1 rounded-full transition duration-300`}
						>
							<FaChevronRight size={14} />
						</button>
					</div>
				)}
			</div>
		</>
	);
};

export default UserLogsInDetail;
